import React, { useEffect, useState } from 'react';
import {
  Divider,
  Stack,
  IconButton,
  Box,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { Collapse } from '@fortress-technology-solutions/fortress-component-library/Transitions';
import { ExpandMoreIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';

const CollapsedCard = ({
  actions,
  divider = false,
  expandedState = false,
  icon,
  notExpandedIcon,
  title,
  subtitle,
  sx,
  children,
  showButton = true,
  expandButtonProps,
  onExpandedChange,
}) => {
  const [expanded, setExpanded] = useState(expandedState);
  useEffect(() => {
    setExpanded(expandedState);
  }, [expandedState]);

  return (
    <>
      <Stack
        direction={'row'}
        justifyContent={'space-between'}
        alignItems={'center'}
      >
        <Stack
          direction={'row'}
          spacing={1}
          justifyContent={'flex-start'}
          alignItems={'center'}
        >
          {expanded ? icon : notExpandedIcon ? notExpandedIcon : icon}

          <div>
            <Typography
              variant={'titleSmall'}
              color={'text.primary'}
              display={'block'}
            >
              {title}
            </Typography>
            {subtitle && (
              <Typography variant={'caption'} color={'text.secondary'}>
                {subtitle}
              </Typography>
            )}
          </div>
        </Stack>

        <Stack spacing={1} direction={'row'}>
          {actions}
          <IconButton
            color={'secondary'}
            sx={{
              pointerEvents: showButton ? 'auto' : 'none',
              opacity: showButton ? 1 : 0,
              transition: ({ transitions }) => transitions.create('opacity'),
              backgroundColor: expanded ? 'divider' : '',
            }}
            onClick={(e) => {
              e.stopPropagation();
              setExpanded(!expanded);
              onExpandedChange?.(!expanded);
            }}
            {...expandButtonProps}
          >
            <ExpandMoreIcon
              sx={{
                transition: ({ transitions: { create } }) =>
                  create('transform'),
                transform: `rotate(${expanded ? 180 : 0}deg)`,
              }}
            />
          </IconButton>
        </Stack>
      </Stack>
      <Collapse in={expanded}>
        <Box sx={{ ...sx, textAlign: 'left', marginY: expanded ? 2 : 0 }}>
          {children}
        </Box>
      </Collapse>
      {divider && <Divider sx={{ marginY: 2 }} />}
    </>
  );
};

export default CollapsedCard;
